import { type ComponentType, type FC, memo, useState } from 'react';
import { RichTextEditor } from '../rich-text-editor';
import { Image as DefaultImage, type ImageProps as ImageProperties } from '../ui';

type ExtractProperties<T> = T extends FC<infer K> ? K : never;

type P = {
  data: string;
  Image?: ComponentType<Pick<ImageProperties, 'rootClassName' | 'src'>>;
  marginBottom?: boolean;
  marginTop?: boolean;
  PreviewGroup?: ComponentType<Pick<ExtractProperties<typeof DefaultImage.PreviewGroup>, 'children' | 'preview'>>;
};

const RichTextRenderer = ({
  data,
  Image = DefaultImage,
  marginBottom,
  marginTop,
  PreviewGroup = DefaultImage.PreviewGroup,
}: P) => {
  const [sources, setSources] = useState<string[]>();
  const [index, setIndex] = useState(0);

  return (
    <div className="rich-text-renderer">
      <PreviewGroup
        preview={{
          current: index,
          onChange(current) {
            setIndex(current);
          },
          onVisibleChange(visible) {
            if (!visible) {
              setSources(undefined);
            }
          },
          visible: Boolean(sources),
        }}
      >
        {sources?.map((source) => (
          <Image key={source} rootClassName="rich-text-renderer__image" src={source} />
        ))}
      </PreviewGroup>

      <RichTextEditor
        data={data}
        editable={false}
        marginBottom={marginBottom}
        marginTop={marginTop}
        onImagePreview={(sources_, index_) => {
          setSources(sources_);
          setIndex(index_);
        }}
        toolbar={[]}
      />
    </div>
  );
};

export default memo(RichTextRenderer);
